import React from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import TimeRangeDisplay from "views/components/time-range-picker/TimeRangeDisplay";
import TimeRangeSelectInput from "data-lake/components/TimeRangeSelectInput";
const StyledP = styled.p`
  margin-top: 10px;
  font-weight: bold;
`;
const TimeRangeField = ({ submitButtonText, hourOnly }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const {
    values: { nextTimeRange }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledP, null, t("time_range_field.label")), /* @__PURE__ */ React.createElement("p", null, t("time_range_field.instruction", { submitButtonText })), /* @__PURE__ */ React.createElement(TimeRangeDisplay, { timerange: nextTimeRange, centerTimestamps: true }), /* @__PURE__ */ React.createElement(TimeRangeSelectInput, { timerange: nextTimeRange, disableTimeMinute: hourOnly, disableTimeSecond: hourOnly }));
};
export default TimeRangeField;
